// Order costs (planned vs actual, PMCO) — collapsed by default, loads on first expand.
// Only rendered for profiles with canViewCosts; the endpoint enforces the same right.
import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Coins } from 'lucide-react';
import { useTheme } from '../../../../core/ui/ThemeContext';
import { useLanguage } from '../../../../core/i18n/LanguageContext';
import { Card, Row } from '../ui';
import { getOrderCosts } from '../../api';

export default function CostsPanel({ user, orderId, role }) {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [costs, setCosts] = useState(null);
  const [error, setError] = useState(null);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && costs === null && !error) {
      try {
        setCosts(await getOrderCosts(user, orderId, role));
      } catch (e) {
        setError(e.message);
      }
    }
  };

  const fmt = (v, cur) => `${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2 })} ${cur}`;
  const sub = isDarkMode ? 'text-white/50' : 'text-slate-500';

  return (
    <Card className="mb-3">
      <button type="button" onClick={toggle} className={`w-full flex items-center gap-2 font-semibold ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
        {open ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
        <Coins size={18} /> {t('pm.costs.title')}
      </button>
      {open && (
        <div className="mt-3 text-sm space-y-1.5">
          {error ? <p className={sub}>{error}</p>
            : costs === null ? <p className={sub}>{t('pm.common.loading')}</p>
            : (
              <>
                <Row label={t('pm.costs.planned')} value={fmt(costs.planTotal, costs.currency)} info={t('pm.info.costsPlanned')} />
                <Row label={t('pm.costs.actual')} value={fmt(costs.actualTotal, costs.currency)} info={t('pm.info.costsActual')} />
                {costs.lines.length === 0 && <p className={sub}>{t('pm.costs.empty')}</p>}
              </>
            )}
        </div>
      )}
    </Card>
  );
}
